// extracted by mini-css-extract-plugin
module.exports = {"container":"Service_container__Ai_DX","intro":"Service_intro__sZ9JK","imageWrapper":"Service_imageWrapper__aJKDY","image":"Service_image__Gyxvn","title":"Service_title__d6ppq"};